import { render, staticRenderFns } from "./travelAgencyList.vue?vue&type=template&id=54a846bd&scoped=true"
import script from "./travelAgencyList.vue?vue&type=script&lang=js"
export * from "./travelAgencyList.vue?vue&type=script&lang=js"
import style0 from "./travelAgencyList.vue?vue&type=style&index=0&id=54a846bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a846bd",
  null
  
)

export default component.exports